import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { EmptyFilesUpload } from './EmptyFilesUpload';
import { NoFilesUploadedStyles } from './Styles';

type Props = {
  messageType?: 'information' | 'files';
  document?: boolean;
};

export const NoFilesUploaded = ({
  messageType = 'files',
  document = false,
}: Props) => {
  const { t } = useTranslation();

  const getLabels = () => (
    <>
      <Label fontSize="14" semibold>
        {t(
          messageType === 'files'
            ? 'There aren’t uploaded files'
            : 'There is not information'
        )}
      </Label>
      <Label fontSize="12">{t('Please, retry the operation.')}</Label>
    </>
  );

  return (
    <NoFilesUploadedStyles
      flexDirection={document ? 'row' : 'column'}
      justifyContent="center"
      alignItems="center"
      rowGap="1.2"
    >
      <>
        <EmptyFilesUpload small={document ? true : false} />
        {!document ? (
          <>{getLabels()}</>
        ) : (
          <>
            <div style={{ marginLeft: '20px' }}>{getLabels()}</div>
          </>
        )}
      </>
    </NoFilesUploadedStyles>
  );
};
